// extracted by mini-css-extract-plugin
export default {"logoContainer":"PasswordReset_logoContainer__KWlBp","logo":"PasswordReset_logo__6dPEs"};